import React from "react";
import "./Button.scss"
const Button = ({ text, isloading, onClick, width }) => {
    return (
        <div className="Virasat-Button" onClick={onClick} style={{ width }}>
            {isloading && <div className="loader-btn" />}
            {text}
        </div>
    )
}
export default Button